export default "__VITE_ASSET__DSg$$p2S__"